import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestArticles from "@/pages/home/components/LatestArticles";
import TimelineExplorer from "@/pages/home/components/TimelineExplorer";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import VoicesSection from "@/pages/home/components/VoicesSection";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaSection from "@/pages/home/components/CtaSection";

const anchorNav = [
  { href: "#latest", label: "最新复盘" },
  { href: "#timeline", label: "事件时间线" },
  { href: "#categories", label: "复盘方向" },
  { href: "#faq", label: "常见问题" },
];

const HOME_JSONLD = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "深夜黑料 · 事件复盘档案库",
    url: "https://midnight-archive.example/",
    inLanguage: "zh-CN",
    description:
      "专注娱乐行业公开事件复盘的内容档案库，按时间线还原事件全貌与前后因果。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://midnight-archive.example/archive?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "深夜黑料 · 事件复盘档案库",
    url: "https://midnight-archive.example/",
    email: "editor@midnight-archive.example",
    description:
      "以时间线为核心的娱乐行业公开事件复盘内容团队，只整理可查证的公开信息。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: "深夜黑料 · 事件复盘档案库 | 时间线考古与因果梳理",
    description:
      "深夜黑料汇总娱乐行业公开事件的完整时间线、事件细节与前后因果，帮你快速理清来龙去脉。想找旧事重提的讨论焦点或补上漏掉的深挖内容，从这里入手。",
    keywords: "深夜黑料,深夜黑料深挖,深夜黑料复盘,深夜黑料考古,深夜黑料旧账,深夜黑料回顾",
    path: "/",
    jsonLd: HOME_JSONLD,
  });

  return (
    <>
      <HeroSection />

      <nav
        aria-label="页内导航"
        className="sticky top-[72px] z-30 border-y border-background-200/70 bg-background-50/92 backdrop-blur-md"
      >
        <div className="mx-auto flex max-w-content items-center gap-1 overflow-x-auto px-4 py-2 md:px-6">
          <span className="mr-2 hidden shrink-0 items-center gap-2 text-xs tracking-[0.2em] text-foreground-500 sm:flex">
            <i className="ri-links-line text-base" />
            页内导航
          </span>
          {anchorNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm text-foreground-600 transition-colors duration-200 hover:bg-background-200/70 hover:text-foreground-950 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>
      </nav>

      <LatestArticles />
      <TimelineExplorer />
      <CategoryGrid />
      <VoicesSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}